import ModalBase from "components/shared/ModalBase";
import StyledButton from "components/shared/StyledButton";
import { SmallBody } from "helpers/TypographyComponents";
import { useState } from "react";
import { forceSendAgreement } from "store/agreementsStore";
import { useAppDispatch } from "store/store";

import type { AgValidationModalType } from "..";
import { useAgreementPageContext } from "../context/StateProvider";

interface ICrealoTeamModal {
    modalType: AgValidationModalType;
    setModalType: (modal: AgValidationModalType) => void;
}

const CrealoTeamModal = ({ modalType, setModalType }: ICrealoTeamModal) => {
    const { agreement } = useAgreementPageContext();
    const [isForceSending, setIsForceSending] = useState(false);
    const dispatch = useAppDispatch();

    const handleForceSendForSignature = async () => {
        if (!agreement) return;
        try {
            setIsForceSending(true);
            const response = await dispatch(forceSendAgreement({ agreementId: agreement.id }) as any);
            if (response.meta.requestStatus === "fulfilled") {
                setModalType(null);
            }
        } finally {
            setIsForceSending(false);
        }
    };

    return (
        <ModalBase
            open={modalType === "force-send-agreement"}
            onClose={() => setModalType(null)}
            modalTitle="[Crealo Team] Forcer l'envoi du contrat pour signature"
        >
            <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
                <div>
                    <SmallBody>Le contrat sera envoyé pour signature à toutes les parties.</SmallBody>
                    <SmallBody>Tous les validateurs doivent avoir approuvé le contrat.</SmallBody>
                    <br />
                    <SmallBody color="info">
                        [DEV] Note : Le contrat ne doit pas avoir de storageId. Les signataires doivent être en
                        signedStatus 0 et ne pas avoir de signatureUrl
                    </SmallBody>
                </div>
                <StyledButton buttonType="secondary" onClick={handleForceSendForSignature} loading={isForceSending}>
                    {`Envoyer pour signature`}
                </StyledButton>
            </div>
        </ModalBase>
    );
};

export default CrealoTeamModal;
